export const Permissions = {
	ORDER_EXPORT: 'order.export',
	ACCOUNT_CREATE: 'account.create',
    TRANSACTION_CREATE: 'transaction.create'
}